/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/laptop_medium'
export default icon
